import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import styles from './style.scss';

function Part(props) {
    const { classes, text } = props;

    return (
        <data data-value={classes} className={styles[classes]}>
            {text}
        </data>
    );
}

Part.displayName = displayName('Text/HighlightText/Part');

Part.propTypes = {
    classes: PropTypes.string,
    text: PropTypes.string,
};

Part.defaultProps = {
    classes: '',
    text: '',
};

export default function HighlightText(text = '', searches = []) {
    if (text && text.length > 0 && searches.length && searches.every(search => search.length > 0)) {
        const modifiedSearches = searches.join('|').replace(/[[\]{}()*+?.,\\^$#\s]/g, '');

        const replace = new RegExp(modifiedSearches, 'gi');
        let parts = [];
        let startIndex = 0;
        let found = replace.exec(text);

        const addPart = (_parts, ...newParts) => _parts.concat(newParts.map((part, i) => {
            const key = `${_parts.length}-${i}`;

            return cloneElement(part, { key });
        }),);

        if (found && !found[0]) {
            const joinedSearches = searches.join('|');
            startIndex = text.indexOf(joinedSearches);

            if (startIndex > -1) {
                parts = addPart(
                    parts,
                    <Part text={text.substr(startIndex, joinedSearches.length)} classes="highlighted-text" />,
                );
                startIndex = joinedSearches.length;
            } else {
                startIndex = 0;
            }
        }

        while (found && found[0]) {
            const matchLength = found[0].length;

            parts = addPart(
                parts,
                <Part text={text.substr(startIndex, found.index - startIndex)} />,
                <Part text={text.substr(found.index, matchLength)} classes="highlighted-text" />,
            );

            startIndex = found.index + matchLength;
            found = replace.exec(text);
        }

        return addPart(parts, <Part text={text.substr(startIndex)} />);
    }

    return text;
}
